// ------------------------------------------------------------------------------
// name:  user 用户相关
// -----------------------------------------------------------------------------
// state

import services from '../../services';
import menu from '@/mock/customerServiceMenu.json';
import utils from '../../utils';

const State = {
  menuData: [], // 菜单数据
  resourceData: [], // 资源数据
  userInfor: {}, // 用户信息
  loginForm: '',
  needUpdatePassword: false,
};

// getters
const Getters = {
  menuData: state => state.menuData,
  resourceData: state => state.resourceData,
  userInfor: state => state.userInfor,
  getIsRemember: state => state.loginForm,
  userId: state => state.userInfor.id,
  needUpdatePassword: state => state.needUpdatePassword,
};

// mutations
const Mutations = {
  setMenuData(state, commData) {
    state.menuData = commData;
  },
  setResourceData(state, resourceData) {
    state.resourceData = resourceData;
  },
  SETUSERINFOR(state, userInfor) {
    state.userInfor = userInfor;
  },
  GETUSERINFOR(state) {
    state.userInfor = utils.getStorage({
      type: 'localStorage',
      key: 'userInfor',
    });
  },
  GETRESOURCEDATA(state) {
    state.resourceData = utils.getStorage({
      type: 'localStorage',
      key: 'resourceData',
    });
  },
  SETISREMEMBER(state, loginForm) {
    state.loginForm = loginForm;
    utils.setStorage({
      type: 'localStorage',
      key: 'isRemember',
      parameter: loginForm,
    });
  },
  REMOVEISREMEMBER(state) {
    state.loginForm = '';
    utils.removeStorage({
      type: 'localStorage',
      key: 'isRemember',
    });
  },
  setUpdatePassword(state, needUpdatePassword) {
    state.needUpdatePassword = needUpdatePassword;
  },
};

// actions
const Actions = {
  setMenuData({commit}) {
    // if (process.env.NODE_ENV !== 'production') {
    //   commit('setMenuData', menu);
    // }
    // else {
    // }
    return new Promise(resolve => {
      let userInfor = utils.getStorage({
        type: 'localStorage',
        key: 'userInfor',
      });
      services.post({
        type: 'USERMANGEMENT',
        url: 'getUserMenuList',
        params: {
          id: userInfor.id,
        },
      }).then(res => {
        if (res.status) {
          commit('setMenuData', res.bean);
        }
        resolve(res);
      });
    });
  },
  setResourceData({commit}, resourceData) {
    utils.setStorage({
      type: 'localStorage',
      key: 'resourceData',
      parameter: resourceData,
    });
    commit('setResourceData', resourceData);
  },
  setUserInfor({commit}, userInfor) {
    commit('SETUSERINFOR', userInfor);
    utils.setStorage({
      type: 'localStorage',
      key: 'userInfor',
      parameter: userInfor,
    });
  },
  getUserInfor({commit}) {
    commit('GETUSERINFOR');
  },
  getResourceData({commit}) {
    commit('GETRESOURCEDATA');
  },
  setIsRemember({commit}, loginForm) {
    commit('SETISREMEMBER', loginForm);
  },
  removeIsRemember({commit}) {
    commit('REMOVEISREMEMBER');
  },
  setUpdatePassword({commit}, needUpdatePassword) {
    commit('setUpdatePassword', needUpdatePassword);
  },
};

export default {
  namespaced: true,
  strict: true,
  state: State,
  getters: Getters,
  actions: Actions,
  mutations: Mutations,
};
